import { Banner } from '@if/mui'
import { useCompany } from '@src/services/company-hooks'
import { useTranslation } from 'react-i18next'
import TransactionRetryMain from './TransactionRetryMain'

const FailedTransactionsSection = () => {
  const { t } = useTranslation()
  const selectedCompany = useCompany()

  if (!selectedCompany) {
    return <Banner severity="info">{t('admin.transactionRetry.messages.selectCompany')}</Banner>
  }

  return <TransactionRetryMain />
}

export default FailedTransactionsSection
